import { mapActions, mapGetters, mapMutations } from 'vuex'
import dialogView from './dialog-view/index.vue'
import analysisOptionsFilter from '../../components/analysis-options-filter/index.vue'

export default {
    name: 'setting-analysis-options',
    data () {
        return {
            page: 1,
            showRemoveDialog: false,
            removedItem: null
        }
    },
    components: {
        dialogView,
        analysisOptionsFilter
    },
    computed: {
        ...mapGetters({
            list: 'settingAnalysisOptions/list',
            limit: 'settingAnalysisOptions/limit',
            listLength: 'settingAnalysisOptions/listLength',
            isLoading: 'settingAnalysisOptions/isLoading',
            isListLoading: 'settingAnalysisOptions/isListLoading',
            openDialogView: 'settingAnalysisOptions/openDialogView'
        }),
        headers () {
            return [
                {
                    text: 'ID',
                    value: 'id'
                },
                {
                    text: 'Sort',
                    value: 'sort'
                },
                {
                    text: 'Key',
                    value: 'key'
                },
                {
                    text: 'Lang',
                    value: 'lang'
                },
                {
                    text: 'Group',
                    value: 'group'
                },
                {
                    text: 'Value',
                    value: 'value'
                },
                {
                    text: 'Actions',
                    sortable: false,
                    value: 'actions'
                }
            ]
        }
    },
    created () {
        this.fetchList()
    },
    methods: {
        ...mapActions({
            fetchList: 'settingAnalysisOptions/GET_LIST',
            remove: 'settingAnalysisOptions/DELETE'
        }),
        ...mapMutations({
            changeSkip: 'settingAnalysisOptions/CHANGE_SKIP',
            changeDialogView: 'settingAnalysisOptions/CHANGE_DIALOG_VIEW',
            changeEditId: 'settingAnalysisOptions/CHANGE_EDIT_ID',
            setCurrentItem: 'settingAnalysisOptions/SET_ITEM'
        }),
        openCreate () {
            this.changeEditId('')
            this.setCurrentItem(null)
            this.changeDialogView(true)
        },
        changeDialog (status = false, item = null) {
            this.changeEditId(item ? item.id : '')
            this.changeDialogView(status)
        },
        changeDialogRemove (item) {
            this.showRemoveDialog = !!item
            this.removedItem = item
        },
        removeListItem () {
            this.remove(this.removedItem).then(() => {
                this.showRemoveDialog = false
                this.$toasted.success(this.$t('success_deleted'))
            })
        }
    }
}
